import { useCallback, useEffect } from "react"
import queryString from "query-string"

import ApiConstants from "../../../helpers/api_constants"
import { CO_API } from "../../../helpers/constants"
import useApi from "../../custom/hooks/api"
import { loginSuccess } from "../../user"
import CommonApiCalls from "./../../../helpers/commonApiCalls"
import appEventEmitter, { AppEvents } from "./../../../helpers/AppEventEmitter"
import tapfiliateTracker from "../../../helpers/tapfiliate_tracker"

/* possible values */
// const btnTexts = ['signup_with', 'signin_with', 'continue_with', 'signin']
// const btnTheme = ['filled_black', 'filled_blue', 'outline']
// const btnSize = ['large', 'medium', 'small']
// const context = ['signin', 'signup', 'use']
// const btnType = ['icon', 'standard']
// const btnIconShape = ['square', 'circle']
// const btnStandardShape = ['pill', 'rectangular']
// const btnWidth =  40 ~ 400px


const GoogleSSO = ({
  renderButton = true,
  divID = 'g_sso_btn',
  btnTheme = 'outline',
  btnSize = 'large',
  btnShape = 'rectangular',
  btnText = 'signin_with',
  btnType = 'standard',
  btnWidth = 240,
  promptReq = false,
  context = 'signin',
  ...props
}) => {
  const { response, error, reqIdentifier, clearRequest, sendRequest } = useApi()
  const { history, dispatch, setGSSOError } = props

  // added affiliate tracker 
  useEffect(() => {
    tapfiliateTracker.updateTrackingId()
  }, [])

  useEffect(() => {
    google.accounts.id.initialize({
      client_id: GOOGLE_SSO_CLIENT_ID,
      callback: handleCredentialResponse,
      cancel_on_tap_outside: true,
      context
    })

    if (renderButton)
      google.accounts.id.renderButton(
        document.getElementById(divID),
        { theme: btnTheme, size: btnSize, shape: btnShape, text: btnText, type: btnType, logo_alignment: 'left', width: btnWidth })

    if (promptReq)
      google.accounts.id.prompt()

  }, [renderButton, promptReq, divID, context, btnTheme, btnText, btnSize, btnShape, btnType, btnWidth, handleCredentialResponse])

  useEffect(() => {
    if (reqIdentifier === ApiConstants.GOOGLE_SSO.REQ_IDENTIFIER) {
      if (response && reqIdentifier === ApiConstants.GOOGLE_SSO.REQ_IDENTIFIER) {
        clearRequest()
        if (response.status === CO_API.Success) {
          if (response.data.allow_two_step_activation === false) {
            appEventEmitter.emit(AppEvents.signup_success, {
              ...response.data,
              app_version: APP_VERSION,
            })

            dispatch(loginSuccess(response.data));
            CommonApiCalls.updateUserSettings(response.data, dispatch)
            appEventEmitter.emit(AppEvents.user_login_success, {
              ...response.data,
              app_version: APP_VERSION,
            })

          } else {
            // based on response take to signup or login the user
            if (!response.data.token) {
              appEventEmitter.emit(AppEvents.signup_success, {
                ...response.data,
                app_version: APP_VERSION,
              })
              let searchParams = `?name=${response.data.name}&id_token=${response.data.id_token}&gather_more=${response.data.gather_more}&method=sso`
              if (response.data.locale && response.data.locale.timezone) {
                searchParams = searchParams + `&time_zone=${response.data.locale.timezone}`
              }
              history.push({
                pathname: '/signup',
                search: searchParams
              })
            } else {
              dispatch(loginSuccess(response.data));
              CommonApiCalls.updateUserSettings(response.data, dispatch)
              appEventEmitter.emit(AppEvents.user_login_success, {
                ...response.data,
                app_version: APP_VERSION,
              })
            }
          }


        } else {
          if (setGSSOError) {
            setGSSOError(response)
          }
        }
      }

      if (error) {
        clearRequest()
        console.log('sso api failed: ', error)
      }
    }
  }, [response, error, reqIdentifier, history, dispatch, clearRequest, setGSSOError])

  const handleCredentialResponse = useCallback((resp) => {
    let body = {
      credential: resp,
      params: queryString.parse(props.location.search),
      type: "individual",
      vid: props.vid
    }

    if (window.tapfiliateTrackingId) {
      body.affiliate = {
        type: "tapfiliate",
        data: {
          tracking_id: window.tapfiliateTrackingId,
        }
      }
    }

    sendRequest({
      apiName: ApiConstants.GOOGLE_SSO.NAME,
      reqIdentifier: ApiConstants.GOOGLE_SSO.REQ_IDENTIFIER,
      body
    })
  }, [sendRequest, props.location.search, props.vid])

  return null
}

export default GoogleSSO